import { ComponentProps, forwardRef } from 'react';
import cn from 'clsx';
import { PolymorphicComponent } from '../../types';

import styles from './BaseCell.module.scss';

const defaultElement = 'td';

export type BaseCellOwnProps = {
  as: 'th' | 'td';
};

type BaseCellComponent = PolymorphicComponent<'td', BaseCellOwnProps>;

export const BaseCell = forwardRef(
  (
    {
      as: Element = defaultElement,
      className,
      children,
      ...restProps
    }: ComponentProps<BaseCellComponent>,
    ref
  ) => (
    <Element
      ref={ref}
      className={cn(styles.baseCell, className)}
      {...restProps}
    >
      {children}
    </Element>
  )
) as BaseCellComponent;
